import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Alert, Button, Heading, RichTextEditor } from '@innovationnorway/cl-react';
import { OneWayInServiceProviderDto } from 'src/api/v2';

interface WriteMessageToActorStepProps {
  referTo: OneWayInServiceProviderDto;
  initialActorMessage: string;
  setActorMessage: React.Dispatch<React.SetStateAction<string>>;
  sanitizedActorMessage: string;
  onPrevious: () => void;
  onNext: () => void;
}

const WriteMessageToActorStep = ({
  referTo,
  initialActorMessage,
  setActorMessage,
  sanitizedActorMessage,
  onPrevious,
  onNext,
}: WriteMessageToActorStepProps) => {
  const { t: tCommon } = useTranslation();
  const { t: tOneWayIn } = useTranslation('oneWayIn');

  const [messageError, setMessageError] = useState(false);

  return (
    <>
      <Heading level={2} className="refer-dialog--heading">
        {tOneWayIn('actionbar.Refer')}
      </Heading>
      <div className="refer-dialog--layout">
        <div className="refer-dialog--body gap--ds-5 margin-bottom--ds-5">
          <span>{tOneWayIn('refer.dialog.writeMessageToActor', { name: referTo?.name })}</span>
          <span className="font-weight--500 font-size--large">{`${tCommon('subject')}: Ny henvisning i Flerbedriftsportalen`}</span>
          <RichTextEditor
            key={initialActorMessage}
            rows={12}
            initialValue={initialActorMessage}
            onChange={(value) => setActorMessage(value)}
          />
          <span>MERK: Svar til denne e-postadressen blir ikke behandlet.</span>
        </div>
        {messageError && (
          <Alert data-color="danger" className="font-weight--500 margin-left--ds-6">
            {tOneWayIn('refer.validation.messageEmpty')}
          </Alert>
        )}
        <div className="refer-dialog--action-row">
          <Button
            variant="secondary"
            onClick={() => {
              onPrevious();
            }}
          >
            {tCommon('previous')}
          </Button>
          <Button
            onClick={() => {
              if (sanitizedActorMessage === '' || sanitizedActorMessage === '<p><br></p>') {
                setMessageError(true);
                return;
              }
              setMessageError(false);
              onNext();
            }}
          >
            {tOneWayIn('refer.dialog.sendReferral')}
          </Button>
        </div>
      </div>
    </>
  );
};

export default WriteMessageToActorStep;
